<!-- eslint-disable vue/no-mutating-props -->
<!-- 配送规则与配送范围的弹窗模块。表单状态由父页面集中管理。 -->
<template>
  <el-dialog
    :model-value="deliveryRuleEditorVisible"
    :title="isEditingDeliveryRule ? '编辑配送规则' : '新增配送规则'"
    width="760px"
    @update:model-value="emit('update:deliveryRuleEditorVisible', $event)"
  >
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions detail-actions--store">
          <GuidedField label="规则名称" hint="便于后台识别这条配送收费规则。" required>
            <el-input v-model.trim="deliveryRuleForm.name" placeholder="如 城区配送规则" />
          </GuidedField>
          <GuidedField label="适用门店" hint="不选择表示全部门店。">
            <el-select v-model="deliveryRuleStoreIds" multiple filterable placeholder="全部门店">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="起送金额" hint="订单达到该金额才允许配送，单位为元。">
            <el-input v-model.number="deliveryRuleForm.minOrderAmount" type="number" step="0.01" placeholder="如 20，表示满 ¥20" />
          </GuidedField>
          <GuidedField label="基础配送费" hint="配送起步费用，单位为元。">
            <el-input v-model.number="deliveryRuleForm.baseFee" type="number" step="0.01" placeholder="如 5，表示 ¥5" />
          </GuidedField>
          <GuidedField label="每公里加价" hint="超过起始距离后，每增加 1 公里收取的费用，单位为元。">
            <el-input v-model.number="deliveryRuleForm.perKmFee" type="number" step="0.01" placeholder="如 1，表示 ¥1" />
          </GuidedField>
          <GuidedField label="免配送费门槛" hint="订单达到该金额后免配送费，单位为元；0 表示不免配送费。">
            <el-input v-model.number="deliveryRuleForm.freeThreshold" type="number" step="0.01" placeholder="如 50，表示满 ¥50" />
          </GuidedField>
          <GuidedField label="起始距离" hint="从多少公里开始计算超距离费用。">
            <el-input v-model.number="deliveryRuleForm.startDistanceKm" type="number" placeholder="如 3" />
          </GuidedField>
          <GuidedField label="最大配送距离" hint="超过该距离的订单不接受配送。">
            <el-input v-model.number="deliveryRuleForm.maxDistanceKm" type="number" placeholder="如 10" />
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:deliveryRuleEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="deliveryRuleSubmitting" @click="emit('submitDeliveryRule')">保存</el-button>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="deliveryAreaEditorVisible"
    title="新增配送范围"
    width="720px"
    @update:model-value="emit('update:deliveryAreaEditorVisible', $event)"
  >
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions detail-actions--store">
          <GuidedField label="适用门店" hint="选择这条配送范围归属的门店。" required>
            <el-select v-model="deliveryAreaStoreIds" multiple filterable placeholder="请选择门店">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="范围类型" hint="半径范围适合圆形配送区，多边形适合不规则区域。">
            <el-select v-model="deliveryAreaForm.type">
              <el-option label="半径范围" value="RADIUS" />
              <el-option label="多边形范围" value="POLYGON" />
            </el-select>
          </GuidedField>
          <GuidedField label="覆盖半径" hint="仅半径范围使用，单位为公里。">
            <el-input v-model.number="deliveryAreaForm.radiusKm" type="number" :disabled="deliveryAreaForm.type !== 'RADIUS'" placeholder="如 5" />
          </GuidedField>
          <GuidedField label="多边形坐标串" hint="仅多边形范围使用，请填写地图坐标串。" wide>
            <el-input v-model.trim="deliveryAreaForm.polygon" :disabled="deliveryAreaForm.type !== 'POLYGON'" placeholder="请输入坐标串" />
          </GuidedField>
          <GuidedField label="附加配送费" hint="该范围额外收取的配送费，单位为元。">
            <el-input v-model.number="deliveryAreaForm.feeTier" type="number" step="0.01" placeholder="单位：元" />
          </GuidedField>
          <GuidedField label="展示排序" hint="数值越小越靠前。">
            <el-input v-model.number="deliveryAreaForm.sort" type="number" placeholder="如 10" />
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:deliveryAreaEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="deliveryAreaSubmitting" @click="emit('submitDeliveryArea')">保存</el-button>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="deliveryPointEditorVisible"
    :title="deliveryPointForm.id ? '编辑配送点' : '新增配送点'"
    width="880px"
    @update:model-value="emit('update:deliveryPointEditorVisible', $event)"
  >
    <div class="detail-grid detail-grid--single">
      <article class="detail-card">
        <div class="detail-actions detail-actions--store">
          <GuidedField label="配送点名称" hint="小程序展示给用户的固定送达点名称。" required>
            <el-input v-model.trim="deliveryPointForm.name" placeholder="如 南山智园 A 座无人机柜" />
          </GuidedField>
          <GuidedField label="归属门店" hint="不选择表示全部门店可用。">
            <el-select v-model="deliveryPointForm.storeId" filterable clearable placeholder="全部门店">
              <el-option v-for="store in storeOptions" :key="store.id" :label="store.name" :value="store.id" />
            </el-select>
          </GuidedField>
          <GuidedField label="服务半径" hint="用户地址会优先匹配半径内最近点位，单位公里。">
            <el-input-number v-model="deliveryPointForm.serviceRadiusKm" :min="0" :precision="1" :step="0.1" controls-position="right" />
          </GuidedField>
          <GuidedField label="展示排序" hint="同距离或展示全部点位时，数值越小越靠前。">
            <el-input-number v-model="deliveryPointForm.sort" :min="0" controls-position="right" />
          </GuidedField>
          <GuidedField label="是否启用" hint="停用后不参与用户地址匹配。">
            <el-switch v-model="deliveryPointForm.enabled" active-text="启用" inactive-text="停用" />
          </GuidedField>
          <GuidedField label="联系人">
            <el-input v-model.trim="deliveryPointForm.contactName" placeholder="如 王站长" />
          </GuidedField>
          <GuidedField label="联系电话">
            <el-input v-model.trim="deliveryPointForm.contactPhone" placeholder="如 028-8888" />
          </GuidedField>
          <GuidedField label="备注">
            <el-input v-model.trim="deliveryPointForm.remark" placeholder="如 柜体在一楼东门外" />
          </GuidedField>
          <GuidedField label="点位地址" hint="可手动填写，也可在地图搜索后确认。" wide required>
            <el-input v-model.trim="deliveryPointForm.address" placeholder="请输入配送点详细地址" />
          </GuidedField>
          <GuidedField label="地图选点" hint="搜索地址或点击地图后，点击确认保存位置。" wide required>
            <MapLocationPicker
              v-model:address="deliveryPointForm.address"
              v-model:longitude="deliveryPointForm.longitude"
              v-model:latitude="deliveryPointForm.latitude"
            />
          </GuidedField>
        </div>
      </article>
    </div>
    <template #footer>
      <el-button @click="emit('update:deliveryPointEditorVisible', false)">取消</el-button>
      <el-button type="primary" :loading="deliveryPointSubmitting" @click="emit('submitDeliveryPoint')">保存</el-button>
    </template>
  </el-dialog>

  <el-dialog
    :model-value="deliveryPointLocationVisible"
    title="配送点位置"
    width="560px"
    @update:model-value="emit('update:deliveryPointLocationVisible', $event)"
  >
    <div v-if="selectedDeliveryPoint" class="point-location">
      <strong>{{ selectedDeliveryPoint.name }}</strong>
      <span>{{ selectedDeliveryPoint.address }}</span>
      <div class="point-location__coords">
        <span>经度：{{ selectedDeliveryPoint.longitude }}</span>
        <span>纬度：{{ selectedDeliveryPoint.latitude }}</span>
      </div>
      <el-button type="primary" plain tag="a" :href="amapUrl(selectedDeliveryPoint)" target="_blank">
        在地图中查看
      </el-button>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import GuidedField from '@/components/GuidedField.vue'
import MapLocationPicker from '@/components/MapLocationPicker.vue'
import type { AdminStore } from '@/api/store'
import type { DeliveryAreaSavePayload, DeliveryPoint, DeliveryPointSavePayload, DeliveryRuleSavePayload } from '@/api/delivery'

const props = defineProps<{
  deliveryRuleEditorVisible: boolean
  deliveryAreaEditorVisible: boolean
  deliveryPointEditorVisible: boolean
  deliveryPointLocationVisible: boolean
  deliveryRuleSubmitting: boolean
  deliveryAreaSubmitting: boolean
  deliveryPointSubmitting: boolean
  deliveryRuleForm: DeliveryRuleSavePayload
  deliveryAreaForm: DeliveryAreaSavePayload
  deliveryPointForm: DeliveryPointSavePayload
  selectedDeliveryPoint?: DeliveryPoint
  deliveryRuleStoreIds: string[]
  deliveryAreaStoreIds: string[]
  storeOptions: AdminStore[]
}>()

const emit = defineEmits<{
  'update:deliveryRuleEditorVisible': [value: boolean]
  'update:deliveryAreaEditorVisible': [value: boolean]
  'update:deliveryPointEditorVisible': [value: boolean]
  'update:deliveryPointLocationVisible': [value: boolean]
  'update:deliveryRuleStoreIds': [value: string[]]
  'update:deliveryAreaStoreIds': [value: string[]]
  submitDeliveryRule: []
  submitDeliveryArea: []
  submitDeliveryPoint: []
}>()

const isEditingDeliveryRule = computed(() => Boolean(props.deliveryRuleForm.id))
const deliveryRuleStoreIds = computed({
  get: () => props.deliveryRuleStoreIds,
  set: (value: string[]) => emit('update:deliveryRuleStoreIds', value),
})
const deliveryAreaStoreIds = computed({
  get: () => props.deliveryAreaStoreIds,
  set: (value: string[]) => emit('update:deliveryAreaStoreIds', value),
})
const {
  deliveryRuleEditorVisible,
  deliveryAreaEditorVisible,
  deliveryPointEditorVisible,
  deliveryPointLocationVisible,
  deliveryRuleSubmitting,
  deliveryAreaSubmitting,
  deliveryPointSubmitting,
  deliveryRuleForm,
  deliveryAreaForm,
  deliveryPointForm,
  selectedDeliveryPoint,
  storeOptions,
} = toRefs(props)

const amapUrl = (point: DeliveryPoint): string =>
  `https://uri.amap.com/marker?position=${point.longitude},${point.latitude}&name=${encodeURIComponent(point.name)}`
</script>

<style scoped lang="scss">
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.detail-grid--single { grid-template-columns: 1fr; }
.detail-card { padding: 16px; border: 1px solid var(--jf-color-border); border-radius: 12px; background: #fff; }
.detail-actions--store { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.point-location { display: flex; flex-direction: column; gap: 12px; color: var(--jf-color-text-primary); }
.point-location strong { font-size: 18px; }
.point-location span { color: var(--jf-color-text-secondary); line-height: 1.6; }
.point-location__coords { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; padding: 12px; border: 1px solid var(--jf-color-border); border-radius: 8px; background: var(--jf-color-background); }
@media (max-width: 760px) {
  .detail-actions--store { grid-template-columns: 1fr; }
  .point-location__coords { grid-template-columns: 1fr; }
}
</style>
